import { getScrollContainer, getScrollEventTarget, getScrollTop } from '@theme/scroll-container';

/**
 * Keeps the sticky header in place while the island menu is open.
 * Theme scroll-lock uses overflow:hidden, which unsticks #header-group and
 * makes the header vanish after you scroll. This freezes scroll position
 * instead, so the header never changes position type (no close jerk).
 */
class IslandHeaderDrawerScroll {
  /** @type {number} */
  #lockedTop = 0;

  /** @type {EventTarget | null} */
  #scrollTarget = null;

  /**
   * @param {HTMLDetailsElement} details
   */
  constructor(details) {
    this.details = details;
    this.details.addEventListener('toggle', this.#onToggle);
    if (this.details.open) this.#lock();
  }

  #onToggle = () => {
    if (this.details.open) {
      this.#lock();
      return;
    }

    this.#unlock();
  };

  #lock() {
    this.#unlock();
    this.#lockedTop = getScrollTop();
    this.#scrollTarget = getScrollEventTarget();
    this.#scrollTarget.addEventListener('scroll', this.#freeze, { passive: true });
    document.addEventListener('wheel', this.#preventPageScroll, { passive: false });
    document.addEventListener('touchmove', this.#preventPageScroll, { passive: false });
  }

  #unlock() {
    this.#scrollTarget?.removeEventListener('scroll', this.#freeze);
    document.removeEventListener('wheel', this.#preventPageScroll);
    document.removeEventListener('touchmove', this.#preventPageScroll);
    this.#scrollTarget = null;
  }

  #freeze = () => {
    const container = getScrollContainer();
    if (container.scrollTop === this.#lockedTop) return;
    container.scrollTop = this.#lockedTop;
  };

  /**
   * @param {WheelEvent | TouchEvent} event
   */
  #preventPageScroll = (event) => {
    if (!(event.target instanceof Element)) {
      event.preventDefault();
      return;
    }

    const drawer = event.target.closest('.island-header-drawer .menu-drawer');
    if (drawer) return;

    event.preventDefault();
  };
}

function initIslandHeaderDrawerScroll() {
  document.querySelectorAll('.island-header-drawer .menu-drawer-container').forEach((details) => {
    if (!(details instanceof HTMLDetailsElement)) return;
    if (details.dataset.islandScrollLock === 'true') return;
    details.dataset.islandScrollLock = 'true';
    new IslandHeaderDrawerScroll(details);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIslandHeaderDrawerScroll, { once: true });
} else {
  initIslandHeaderDrawerScroll();
}
